import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation, useOutlet } from "react-router-dom";

const Wrapper = styled(Box)`
  flex-grow: 1;
  z-index: -0;
`;

export default function MainContent() {
  const element = useOutlet();
  const location = useLocation();

  const heightPage = ["event/booking-verification"].filter((item) =>
    location.pathname.includes(item)
  );

  const marginPage = [
    "/profile",
    "/login",
    "/sign-in",
    "/settings",
    // "/visitor/sign-up",
  ].filter((item) => location.pathname.includes(item));

  return (
    <Wrapper
      style={{
        ...(!marginPage.length && { marginTop: "50px" }),
        ...(heightPage.length && { height: "0" }),
        // height: "calc(100vh - 73px)",
      }}
    >
      {element}
    </Wrapper>
  );
}
